import classNames from 'classnames';
import { Status } from '@Components/Base';

import {
  getCompaniesDictSelector,
  getCostCenterTypeDict,
} from '@Store/selectors/dictionarySelector';
import {
  currentMaterialRequest,
  materialCostCenters,
} from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';

import { useAppSelector, useStatusFinderByNum } from '@Hooks/index';
import { useGetRequisitionQuery } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';
import {
  findCostCenter,
  findCompanyType,
  findCostCenterType,
} from '@Features/MaterialRequest/requests/utils/finder';

import { ReactComponent as CompanyIcon } from '@Icons/additional/logo-company-default.svg';

import fieldSource from '../FieldSource';

import styles from './tab-details-desktop.module.css';

const DetailsTabDesktop: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Material');
  const costCenterTypes = useAppSelector(getCostCenterTypeDict);
  const currentMaterialCostCenters = useAppSelector(materialCostCenters);
  const currentCompanies = useAppSelector(getCompaniesDictSelector);
  const { requestId } = useAppSelector(currentMaterialRequest);
  const { data } = useGetRequisitionQuery(String(requestId), {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  if (!data) return null;

  const costCenterTypeDesc = findCostCenterType(
    costCenterTypes,
    data.ccTypeId
  )?.codeDesc;

  const costCenterName = findCostCenter(
    currentMaterialCostCenters,
    data.ccId
  )?.name;

  const companyName = findCompanyType(data.compId, currentCompanies)?.compName;

  return (
    <div
      className={classNames(
        'trojan-glassphormism-box trojan-glassphormism-box-shadow',
        styles.tab
      )}
    >
      <div className={styles.content}>
        {fieldSource({
          data,
          costCenterTypeDesc,
          costCenterName,
          companyName,
        }).map((item) => (
          <div className={styles.viewItem} key={item.label}>
            <span>{item.label}</span>
            {item.label === 'Status' ? (
              <Status
                className={styles.viewItemValue}
                text={findStatus(Number(item.value))?.codeDesc || ''}
              />
            ) : (
              <span className={styles.viewItemValue}>
                {item.label === 'Company Name' && (
                  <span className={styles.companyIcon}>
                    <CompanyIcon />
                  </span>
                )}
                {item.value}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailsTabDesktop;
